import React from 'react';
import LogInteractionScreen from './components/LogInteractionScreen';
import './index.css';
function App() { return <LogInteractionScreen />; }
export default App;
